import React from 'react';
import classNames from 'classnames';
import ShadedRoundBox from 'Components/ComponentLibrary/Atoms/Ornament/ShadedRoundBox';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import LinkButton from 'Components/ComponentLibrary/Atoms/Inputs/LinkButton';
import PrioritySwitcher from 'Components/ComponentLibrary/Atoms/Inputs/PrioritySwitcher';

const styles = () => ({
  root: {},
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const PriorityItemCard = ({
  className, classes, name, description, subtext, onRaisePriority, onLowerPriority, onClick,
}) => (
  <div
    className={classNames(className, classes.root)}
  >
    <ShadedRoundBox
      test={`select-field-prioritization-item-${name}`}
    >
      <div className={classes.spaceBetween}>
        <div>
          {onClick ? (
            <LinkButton
              variant={'h6'}
              onClick={onClick}
              test={`priority-card-list-item-${name}`}
            >
              {name}
            </LinkButton>
          ) : (
            <Text text={name} weight={'bold'} variant={'h6'} align={'left'} test={`priority-card-list-item-${name}`} />
          )}
          <Text text={description} weight={'bold'} variant={'fineprint'} align={'left'} color={'black'} />
        </div>
        <PrioritySwitcher
          onRaisePriority={onRaisePriority}
          onLowerPriority={onLowerPriority}
        />
      </div>
    </ShadedRoundBox>
    {subtext && (
    <Text text={subtext} weight={'bold'} variant={'fineprint'} align={'left'} color={'error'} />
    )}
  </div>
);

PriorityItemCard.defaultProps = {
  description: '',
  onRaisePriority: null,
  onLowerPriority: null,
  onClick: null,
  className: null,
  subtext: null,
};

PriorityItemCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  subtext: PropTypes.string,
  onRaisePriority: PropTypes.func,
  onLowerPriority: PropTypes.func,
  onClick: PropTypes.func,
};

export default withStyles(styles)(PriorityItemCard);
